import React, { Fragment } from 'react';

const CollectionStats = props => {
  const { skip, limit, productsNum } = props;

  let from;
  skip === 0 ? (from = 1) : (from = skip);

  let to;
  skip + limit > productsNum ? (to = productsNum) : (to = skip + limit);

  if (to) {
    return (
      <Fragment>
        {from} à {to} produits sur {productsNum}
      </Fragment>
    );
  } else {
    return ('Aucun résultats')
  }
};

export default CollectionStats;
